import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 运行查询列表
export function getList(params) {
  return request({
    url: URL.rpaRobot.runningQuery.traces,
    method: 'get',
    params
  })
}
